// src/modules/financials/components/InventoryPipelineSection.jsx
import React from 'react';
import { Card, Row, Col, Statistic, Tag, Empty } from 'antd';
import { Column } from '@ant-design/charts';
import { ContainerOutlined, ArrowRightOutlined } from '@ant-design/icons';

const inr = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;

const statusColor = { HOLDING: '#1890ff', DISPATCHED: '#faad14', SETTLED: '#52c41a' };

const InventoryPipelineSection = ({ data = {}, loading = false }) => {
  const {
    stockInWeight = 0,
    stockOutWeight = 0,
    holdingWeight = 0,
    holdingCost = 0,
    holdingBatches = 0,
    holdingCases = 0,
    dispatchedWeight = 0,
    dispatchedBatches = 0,
    settledWeight = 0,
    settledBatches = 0,
    pipeline = [],
  } = data;

  const chartData = pipeline.map(p => ({
    status: p.status,
    weight: p.totalNetWeight || 0,
    cost: p.totalPurchaseCost || 0,
  }));

  const columnConfig = {
    data: chartData,
    xField: 'status',
    yField: 'weight',
    style: {
      radiusTopLeft: 4,
      radiusTopRight: 4,
      fill: (d) => statusColor[d.status] || '#8c8c8c',
    },
    label: false,
    tooltip: {
      items: [
        (d) => ({
          name: d.status || '',
          value: `${Number(d.weight || 0).toFixed(2)} g — ${inr(d.cost)}`,
        }),
      ],
    },
    axis: {
      y: { title: 'Net Weight (g)' },
    },
  };

  return (
    <Card
      title={<span><ContainerOutlined style={{ color: '#722ed1', marginRight: 8 }} />Inventory Pipeline</span>}
      style={{ borderRadius: 12, border: '1px solid #f0f0f0', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
      loading={loading}
    >
      {/* KPIs row */}
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col xs={12} md={4}>
          <Statistic title="Stock In" value={`${stockInWeight} g`} valueStyle={{ fontSize: 16 }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Stock Out" value={`${stockOutWeight} g`} valueStyle={{ fontSize: 16 }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title={<><Tag color="blue">HOLDING</Tag> Weight</>} value={`${holdingWeight} g`} valueStyle={{ fontSize: 16 }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Holding Cost" value={inr(holdingCost)} valueStyle={{ fontSize: 16, color: '#cf1322' }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title="Batches / Cases" value={`${holdingBatches} / ${holdingCases}`} valueStyle={{ fontSize: 16 }} />
        </Col>
        <Col xs={12} md={4}>
          <Statistic title={<><Tag color="gold">DISPATCHED</Tag></>} value={`${dispatchedBatches} batch — ${dispatchedWeight} g`} valueStyle={{ fontSize: 14 }} />
        </Col>
      </Row>

      {/* Bar chart */}
      {chartData.length > 0 ? (
        <Column {...columnConfig} height={260} />
      ) : (
        <Empty description="No inventory data" />
      )}
    </Card>
  );
};

export default InventoryPipelineSection;
